import * as ApiUrls from './ApiUrl.StaticData';
import { AxiosResponse } from 'axios';
import { axiosCoreInstance } from '../AxiosCoreInterceptor';
import { CoreEnumLookupDto } from '../../Model/Dto/CoreStaticData';
import {ServiceRequiredMatrix} from "../../Model/Dto/VerificationAgency/VerificationAgencyClientApplication";
import { IDropDownOptions } from '../../Common/Components/FormValidationInputs/AppSelectList';
import { ElementWithDataPagesDto } from '../../Model/Dto/StaticData';

export const CoreStaticDataService = {
	getServicesRequired: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(ApiUrls.GetServicesRequired),
	getBBBEECodes: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(ApiUrls.GetBBBEECodes),
	getSectorCodes: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(ApiUrls.GetSectorCodes),
	getScorecardTypeCategories: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(ApiUrls.GetScorecardTypeCategories),
	getOwnershipStructureElements: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(ApiUrls.GetOwnershipStructureElements),
	getBeeScorecardType: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(ApiUrls.GetBeeScorecardType),
	getServiceRequiredCodeMatrix: (): Promise<AxiosResponse<ServiceRequiredMatrix>> =>
		axiosCoreInstance.get(ApiUrls.GetServiceRequiredCodeMatrix),
	getMunicipalities: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(ApiUrls.GetMunicipalities),
	getNationalities: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> => 
		axiosCoreInstance.get(ApiUrls.GetNationalities),
	getScorecardAllowedElements: (scorecardType: number): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(`${ApiUrls.GetScorecardAllowedElements}/${scorecardType}`),
	getScorecardAndUserAllowedDataPages:  (scorecardType: number): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(`${ApiUrls.GetScorecardAndUserAllowedDataPages}/${scorecardType}`),
	getAllScorecardTypes: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(ApiUrls.GetAllScorecardTypes),
	getDeviationReasons: (): Promise<AxiosResponse<CoreEnumLookupDto[]>> =>
		axiosCoreInstance.get(ApiUrls.GetDeviationReasons),
	getElementsWithDataPages: (scorecardType: number): Promise<AxiosResponse<ElementWithDataPagesDto[]>> =>
		axiosCoreInstance.get(`${ApiUrls.GetElementsWithDataPages}/${scorecardType}`)
};
